import { useTranslation } from "react-i18next";
import React, { useState, useEffect, Fragment, useCallback, useRef } from "react";
import { useNavigate, useParams, Prompt } from "react-router-dom";
import apiRequest from "../../functions/api";
import {
  TextField,
  Typography,
  Container,
  Card,
  IconButton,
  MenuItem,
  Table,
  Hidden,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useMediaQuery,
  Button,
  Box,
} from "@mui/material";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import { useMessage } from "../../context/message-context";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import RefreshIcon from "@mui/icons-material/Refresh";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import Child from "./child";
import Grid from "@mui/material/Grid";
import ResponsiveDialog from "../shared/components/ResponsiveDialog";
import axios from "axios";
import { API_BASE_URL } from "../../constants/apiConstants";
import { useTheme } from "@mui/material/styles";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { setColor2, ObjectContentIsEqual } from "../../functions/default";
import openFile from "../shared/functions/download";
import { FullPageSpinner } from "../lib";
import MessageBox from "../shared/components/MessageBox";
import NavigationPrompt from "../shared/components/NavigationPrompt";
function Arbeitszeiterfassung(props) {
  const { t } = useTranslation();
  // Standard Variablen
  const { client, accessToken } = props;
  const { antragid } = useParams();
  const { showErrorMessage } = useMessage();
  const [isLoading, setIsLoading] = useState(false);
  const [, updateState] = useState();
  const forceUpdate = useCallback(() => updateState({}), []);
  const navigate = useNavigate();
  const [open, setOpen] = useState(-1);
  const theme = useTheme();
  // Arbeitsvariablen
  const [zeitraum, setZeitraum] = useState([]);
  const [zeitraumIndex, setZeitraumIndex] = useState("");
  const [zeilen, setZeilen] = useState([]);
  const [prfZeilen, setPrfZeilen] = useState([]);
  const [status, setStatus] = useState("");
  const [statustext, setStatustext] = useState("");
  const [genehmigen, setGenehmigen] = useState("0");
  const [stempelpaare, setStempelpaare] = useState(0);
  const [paare, setPaare] = useState(1);
  const [hinweisvg, setHinweisvg] = useState("");
  const [vdat, setVdat] = useState("");
  const [bdat, setBdat] = useState("");
  const [monattext, setMonattext] = useState("");
  const [vortrag, setVortrag] = useState("");
  const [lfd, setLfd] = useState("");
  const [endstand, setEndstand] = useState("");
  const [saldo, setSaldo] = useState("0");
  const [onlineid, setOnlineid] = useState("");
  const [antragsteller, setAntragsteller] = useState("");
  const [noDel, setNoDel] = useState(0);
  const [archiv, setArchiv] = useState("");
  const saveError = useRef(0);
  const [messageBoxOpen, setMessageBoxOpen] = useState(false);
  const [msbIndex, setMsbIndex] = useState(-1);
  const [vg, setVg] = useState("");
  const [sendfuture, setSendfuture] = useState("");
  const [zeitarten, setZeitarten] = useState([]);
  const [zaaktiv, setZaaktiv] = useState("");
  const [showModal, setShowModal] = useState(false);
  const small = useMediaQuery(theme.breakpoints.down("lg"));
  const [changes, setChanges] = useState(0);
  // Functions
  useEffect(() => {
    setIsLoading(true);
    if (antragid) {
      const payload = {
        mandant: client,
        program: "PMURA3",
        statement: "SPLANT_GENEHMIGEN",
        key: antragid.substring(3),
        antragVon: antragid.substring(0, 3),
      };
      const headers = {
        Authorization: "Bearer " + accessToken,
      };
      apiRequest("POST", "daten", payload, headers, postGenehmigen);
    } else {
      const payload = {
        mandant: client,
        program: "SPLANT",
        statement: "LADE_ANTRAG",
      };
      const headers = {
        Authorization: "Bearer " + accessToken,
      };
      apiRequest("POST", "daten", payload, headers, postLadeAntrag);
    }
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    checkDel();
    // eslint-disable-next-line
  }, [zeilen]);
  function checkDel() {
    var tmpDel = 0;
    zeilen.forEach((item, index) => {
      if (paare >= 1) {
        if (item.szk1 !== "00:00") tmpDel = Math.max(tmpDel, 1);
        if (item.szg1 !== "00:00") tmpDel = Math.max(tmpDel, 1);
      }
      if (paare >= 2) {
        if (item.szk2 !== "00:00") tmpDel = Math.max(tmpDel, 2);
        if (item.szg2 !== "00:00") tmpDel = Math.max(tmpDel, 2);
      }
      if (paare >= 3) {
        if (item.szk3 !== "00:00") tmpDel = Math.max(tmpDel, 3);
        if (item.szg3 !== "00:00") tmpDel = Math.max(tmpDel, 3);
      }
      if (paare >= 4) {
        if (item.szk4 !== "00:00") tmpDel = Math.max(tmpDel, 4);
        if (item.szg4 !== "00:00") tmpDel = Math.max(tmpDel, 4);
      }
      if (paare >= 5) {
        if (item.szk5 !== "00:00") tmpDel = Math.max(tmpDel, 5);
        if (item.szg5 !== "00:00") tmpDel = Math.max(tmpDel, 5);
      }
    });
    setNoDel(tmpDel);
  }
  const postLadeAntrag = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      setZeitraum(response.data.zeitraum);
      setZeitraumIndex("0");
      setStatus(response.data.status);
      setGenehmigen(response.data.genehmigen);
      setSaldo(response.data.saldo);
      setOnlineid(response.data.onlineid);
      setStempelpaare(response.data.stempelpaare);
      setPaare(response.data.paare);
      setNoDel(Number(response.data.paare));
      setArchiv(response.data.archiv);
      setStatustext(response.data.statustext);
      setHinweisvg(response.data.hinweisvg);
      setVdat(response.data.vdat);
      setBdat(response.data.bdat);
      setAntragsteller(response.data.antragsteller);
      setZeilen(response.data.zeilen);
      setPrfZeilen(JSON.parse(JSON.stringify(response.data.zeilen)));
      setVortrag(response.data.vortrag);
      setLfd(response.data.lfd);
      setEndstand(response.data.endstand);
      setSendfuture(response.data.sendfuture);
      setZeitarten(response.data.zeitarten);
      setZaaktiv(response.data.zeitartaktiv);
      setChanges(0);
      forceUpdate();
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
      navigate(-1);
    }
  };
  const postGenehmigen = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      if (response.data.vg) setVg(response.data.vg);
      setZeitraum(response.data.zeitraum);
      setZeitraumIndex("0");
      setMonattext(response.data.monattext);
      setStatus(response.data.status);
      setGenehmigen(response.data.genehmigen);
      setSaldo(response.data.saldo);
      setOnlineid(response.data.onlineid);
      setStempelpaare(response.data.stempelpaare);
      setPaare(response.data.paare);
      setNoDel(Number(response.data.paare));
      setArchiv(response.data.archiv);
      setStatustext(response.data.statustext);
      setHinweisvg(response.data.hinweisvg);
      setVdat(response.data.vdat);
      setBdat(response.data.bdat);
      setZeilen(response.data.zeilen);
      setPrfZeilen(JSON.parse(JSON.stringify(response.data.zeilen)));
      setVortrag(response.data.vortrag);
      setLfd(response.data.lfd);
      setAntragsteller(response.data.antragsteller);
      setEndstand(response.data.endstand);
      setZeitarten(response.data.zeitarten);
      setZaaktiv(response.data.zeitartaktiv);
      setChanges(0);
      forceUpdate();
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  function Aktion(aufgabe) {
    if (aufgabe !== "download") setIsLoading(true);
    if (aufgabe === "genehmigen") {
      const payload = {
        mandant: client,
        program: "PMURA3",
        statement: "SPLANT_ANTRAG_GENEHMIGEN",
        key: antragid.substring(3),
        antragVon: antragid.substring(0, 3),
        zeilen: zeilen,
        vdat: vdat,
        bdat: bdat,
        status: status,
        hinweisvg: hinweisvg,
        paare: paare,
      };
      const headers = {
        Authorization: "Bearer " + accessToken,
      };
      apiRequest("POST", "daten", payload, headers, postAktionGenehmigen);
    }
    if (aufgabe === "ablehnen") {
      const payload = {
        mandant: client,
        program: "PMURA3",
        statement: "SPLANT_ANTRAG_ABLEHNEN",
        key: antragid.substring(3),
        antragVon: antragid.substring(0, 3),
        zeilen: zeilen,
        vdat: vdat,
        bdat: bdat,
        status: status,
        hinweisvg: hinweisvg,
        paare: paare,
      };
      const headers = {
        Authorization: "Bearer " + accessToken,
      };
      apiRequest("POST", "daten", payload, headers, postAktionGenehmigen);
    }
    if (aufgabe === "aktualisieren") {
      const payload = {
        mandant: client,
        program: "SPLANT",
        statement: "ANTRAG_AKTUALISIEREN",
        zeilen: zeilen,
        vdat: vdat,
        bdat: bdat,
        status: status,
        zr: zeitraum[zeitraumIndex].key,
        paare: paare,
      };
      const headers = {
        Authorization: "Bearer " + accessToken,
      };
      apiRequest("POST", "daten", payload, headers, postAktion);
    }
    if (aufgabe === "aendern") {
      const payload = {
        mandant: client,
        program: "SPLANT",
        statement: "ANTRAG_AENDERN",
        zeilen: zeilen,
        vdat: vdat,
        bdat: bdat,
        status: status,
        zr: zeitraum[zeitraumIndex].key,
        paare: paare,
        sendfuture: sendfuture,
      };
      const headers = {
        Authorization: "Bearer " + accessToken,
      };
      apiRequest("POST", "daten", payload, headers, postAktion);
    }
    if (aufgabe === "download") {
      if (genehmigen === "1") {
        setShowModal(true);
        downloadFile(vdat.substr(0, 6));
      } else {
        const payload = {
          mandant: client,
          program: "SPLANT",
          statement: "ANTRAG_AKTUALISIEREN",
          zeilen: zeilen,
          vdat: vdat,
          bdat: bdat,
          status: status,
          zr: zeitraum[zeitraumIndex].key,
          paare: paare,
        };
        const headers = {
          Authorization: "Bearer " + accessToken,
        };
        apiRequest("POST", "daten", payload, headers, postDL);
      }
    }
  }
  const postAktion = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      if (response.data.message === "OK") {
        setMonattext(response.data.monattext);
        setStatus(response.data.status);
        setGenehmigen(response.data.genehmigen);
        setSaldo(response.data.saldo);
        setOnlineid(response.data.onlineid);
        setStempelpaare(response.data.stempelpaare);
        setPaare(response.data.paare);
        setNoDel(Number(response.data.paare));
        setArchiv(response.data.archiv);
        setStatustext(response.data.statustext);
        setHinweisvg(response.data.hinweisvg);
        setVdat(response.data.vdat);
        setBdat(response.data.bdat);
        setPrfZeilen(JSON.parse(JSON.stringify(response.data.zeilen)));
        setVortrag(response.data.vortrag);
        setLfd(response.data.lfd);
        setAntragsteller(response.data.antragsteller);
        setEndstand(response.data.endstand);
        setZeilen(response.data.zeilen);
        setZeitarten(response.data.zeitarten);
        setZaaktiv(response.data.zeitartaktiv);
        setOpen(-1);
        setChanges(0);
        forceUpdate();
        saveError.current = 0;
      } else {
        showErrorMessage(response.data.message);
      }
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  const postDL = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      if (response.data.message === "OK") {
        setMonattext(response.data.monattext);
        setStatus(response.data.status);
        setGenehmigen(response.data.genehmigen);
        setSaldo(response.data.saldo);
        setOnlineid(response.data.onlineid);
        setStempelpaare(response.data.stempelpaare);
        setPaare(response.data.paare);
        setNoDel(Number(response.data.paare));
        setArchiv(response.data.archiv);
        setStatustext(response.data.statustext);
        setHinweisvg(response.data.hinweisvg);
        setVdat(response.data.vdat);
        setBdat(response.data.bdat);
        setPrfZeilen(JSON.parse(JSON.stringify(response.data.zeilen)));
        setVortrag(response.data.vortrag);
        setLfd(response.data.lfd);
        setAntragsteller(response.data.antragsteller);
        setEndstand(response.data.endstand);
        setZeitarten(response.data.zeitarten);
        setZaaktiv(response.data.zeitartaktiv);
        setOpen(-1);
        setChanges(0);
        forceUpdate();
        setShowModal(true);
        downloadFile(vdat.substr(0, 6));
      } else {
        showErrorMessage(response.data.message);
      }
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  function postAktionGenehmigen(response) {
    setIsLoading(false);
    if (response.status === 200) {
      if (response.data.message === "OK") {
        navigate("/PMURA3/");
      } else {
        showErrorMessage(response.data.message);
      }
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }
  function onInputChange(index, item) {
    zeilen[index] = item;
    if (!ObjectContentIsEqual(zeilen, prfZeilen)) {
      setChanges(1);
    } else {
      setChanges(0);
    }
    checkDel();
  }
  function openPanel(index) {
    setOpen(index);
  }
  function Abbrechen() {
    setOpen(-1);
    setZeilen(zeilen);
  }
  function ChangeZR(zr) {
    if (zr === zeitraumIndex) return;
    setIsLoading(true);
    const payload = {
      mandant: client,
      program: "SPLANT",
      statement: "ANTRAG_ZR",
      zeilen: zeilen,
      vdat: vdat,
      bdat: bdat,
      status: status,
      zr: zeitraum[zr].key,
      paare: paare,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, postAktion);
  }
  if (isLoading) {
    return <LoadingComponent />;
  }
  const closeModal = () => {
    setShowModal(false);
  };
  const openDL = () => {
    Aktion("download");
  };
  const downloadFile = (key) => {
    console.log("file with key: ", key);
    var pgm = "SPLANT";
    if (genehmigen === "1") pgm = "PMURA3";
    const payload = {
      mandant: client,
      program: pgm,
      statement: "JOURNAL_LADEN",
      timeperiod: vdat.substr(0, 6),
      key: onlineid,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
      Accept: "application/pdf",
    };
    axios
      .post(API_BASE_URL + "daten", payload, { headers: headers, responseType: "blob" })
      .then((response) => {
        console.log(response);
        var fileName = onlineid ? "Zeitjournal_" + key + "_" + onlineid + ".pdf" : "Zeitjournal_" + key + ".pdf";
        var contentFile = response.data;
        openFile(fileName, contentFile);
        closeModal();
      })
      .catch(function (error) {
        console.log(error);
        closeModal();
        showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
      });
  };
  function Add() {
    var tmppaare = paare;
    tmppaare++;
    setPaare(tmppaare);
  }
  function Del() {
    if (paare <= noDel) {
      showErrorMessage(
        t("Zeitpaare werden immer für den gesamten Monat angegeben/verwendet. Daher ist ein Reduzieren nicht möglich, da das Zeitpaar ") +
          paare.toString() +
          " in diesem Monat bereits verwendet wird. (Es ist aber auch nicht notwendig, dass Sie alle Zeitpaare ausfüllen.)",
      );
    } else {
      var tmppaare = paare;
      tmppaare--;
      setPaare(tmppaare);
    }
  }
  const messageBoxResult = (result) => {
    setMessageBoxOpen(false);
    var index = msbIndex;
    if (result === "YES") {
      var tmpliste = [...zeilen];
      tmpliste[index].szk1 = "";
      tmpliste[index].szg1 = "";
      tmpliste[index].za1 = "00";
      tmpliste[index].szk2 = "";
      tmpliste[index].szg2 = "";
      tmpliste[index].za2 = "00";
      tmpliste[index].szk3 = "";
      tmpliste[index].szg3 = "";
      tmpliste[index].za3 = "00";
      tmpliste[index].szk4 = "";
      tmpliste[index].szg4 = "";
      tmpliste[index].za4 = "00";
      tmpliste[index].szk5 = "";
      tmpliste[index].szg5 = "";
      tmpliste[index].za5 = "00";
      tmpliste[index].zusatz = "";
      setZeilen(tmpliste);
    }
  };
  function Reset(index) {
    setMsbIndex(index);
    setMessageBoxOpen(true);
  }
  // Table Anzeige
  function tableHeader() {
    return (
      <Fragment>
        <Hidden lgDown>
          <TableRow>
            <TableCell align="center" className="tabledesign">
              {t("Datum")}
            </TableCell>
            <TableCell align="center" className="tabledesign">
              {t("Info")}
            </TableCell>
            {((genehmigen === "1" && saldo === "0") || saldo === "2") && (
              <TableCell align="center" className="tabledesign">
                +/-
              </TableCell>
            )}
            {(genehmigen === "1" || status === "A" || status === "N") && (
              <Hidden lgDown>
                <TableCell align="center" className="tabledesign">
                  {t("Kommentar (Vorgesetzter)")}
                </TableCell>
              </Hidden>
            )}
            <Hidden lgDown>
              <TableCell align="center" className="tabledesign">
                {t("Kommentar")}
              </TableCell>
            </Hidden>
            <Hidden lgDown>
              <TableCell align="center" className="tabledesign">
                {t("AZ Kommt 1")}
              </TableCell>
            </Hidden>
            <Hidden lgDown>
              <TableCell align="center" className="tabledesign">
                {t("AZ Geht 1")}
              </TableCell>
              {zaaktiv === "1" && (
                <Hidden lgDown>
                  <TableCell align="center" className="tabledesign">
                    {t("Zeitart 1")}
                  </TableCell>
                </Hidden>
              )}
            </Hidden>
            {paare >= 2 && (
              <Hidden lgDown>
                <TableCell align="center" className="tabledesign">
                  {t("AZ Kommt 2")}
                </TableCell>
              </Hidden>
            )}
            {paare >= 2 && (
              <Hidden lgDown>
                <TableCell align="center" className="tabledesign">
                  {t("AZ Geht 2")}
                </TableCell>
              </Hidden>
            )}
            {paare >= 2 && zaaktiv === "1" && (
              <Hidden lgDown>
                <TableCell align="center" className="tabledesign">
                  {t("Zeitart 2")}
                </TableCell>
              </Hidden>
            )}
            {paare >= 3 && (
              <Hidden lgDown>
                <TableCell align="center" className="tabledesign">
                  {t("AZ Kommt 3")}
                </TableCell>
              </Hidden>
            )}
            {paare >= 3 && (
              <Hidden lgDown>
                <TableCell align="center" className="tabledesign">
                  {t("AZ Geht 3")}
                </TableCell>
              </Hidden>
            )}
            {paare >= 3 && zaaktiv === "1" && (
              <Hidden lgDown>
                <TableCell align="center" className="tabledesign">
                  {t("Zeitart 3")}
                </TableCell>
              </Hidden>
            )}
            {stempelpaare >= 4 && paare >= 4 && (
              <Hidden lgDown>
                <TableCell align="center" className="tabledesign">
                  {t("AZ Kommt 4")}
                </TableCell>
              </Hidden>
            )}
            {stempelpaare >= 4 && paare >= 4 && (
              <Hidden lgDown>
                <TableCell align="center" className="tabledesign">
                  {t("AZ Geht 4")}
                </TableCell>
              </Hidden>
            )}
            {stempelpaare >= 4 && paare >= 5 && zaaktiv === "1" && (
              <Hidden lgDown>
                <TableCell align="center" className="tabledesign">
                  {t("Zeitart 4")}
                </TableCell>
              </Hidden>
            )}
            {stempelpaare >= 5 && paare >= 5 && (
              <Hidden lgDown>
                <TableCell align="center" className="tabledesign">
                  {t("AZ Kommt 5")}
                </TableCell>
              </Hidden>
            )}
            {stempelpaare >= 5 && paare >= 5 && (
              <Hidden lgDown>
                <TableCell align="center" className="tabledesign">
                  {t("AZ Geht 5")}
                </TableCell>
              </Hidden>
            )}
            {stempelpaare >= 5 && paare >= 5 && zaaktiv === "1" && (
              <Hidden lgDown>
                <TableCell align="center" className="tabledesign">
                  {t("Zeitart 5")}
                </TableCell>
              </Hidden>
            )}
          </TableRow>
        </Hidden>
        <Hidden lgUp>
          <TableRow>
            <TableCell align="center">{t("Auswahl Tag")}</TableCell>
          </TableRow>
        </Hidden>
      </Fragment>
    );
  }
  return (
    <Fragment>
      <NavigationPrompt when={changes === 1 && (status === "O" || status === "A")}>
        {(isOpen, onConfirm, onCancel) => (
          <MessageBox
            open={isOpen}
            handleResponse={(response) => {
              if (response === "YES") {
                onConfirm();
              } else {
                onCancel();
              }
            }}
            buttons="YESNO"
            text={t("Es sind Änderungen vorhanden, die noch nicht gespeichert wurden. Möchten Sie die Änderungen verwerfen und das Programm verlassen?")}
            title={t("ACHTUNG!")}
            onClose={() => onCancel()}
          />
        )}
      </NavigationPrompt>
      <ResponsiveDialog
        title={open >= 0 && zeilen && zeilen.length > 0 && zeilen[open].datum}
        open={open >= 0}
        setOpen={(o) => setOpen(-1)}
        actionButton={
          <Fragment>
            <Button color="error" onClick={() => Reset(open)}>
              {t("Zurücksetzen")}
            </Button>
            <Button color="primary" onClick={() => Abbrechen()}>
              {t("Übernehmen")}
            </Button>
          </Fragment>
        }
      >
        <Box p={2}>
          <form>
            {open >= 0 && zeilen && zeilen.length > 0 && (
              <Child
                key={zeilen[open].key}
                zeile={zeilen[open]}
                index={open}
                onChange={onInputChange}
                stempelpaare={stempelpaare}
                paare={paare}
                status={status}
                genehmigen={genehmigen}
                aufgabe="zeile"
                saldo={saldo}
                antragsteller={antragsteller}
                noDel={noDel}
                archiv={archiv}
                add={Add}
                del={Del}
                small={small}
                zaaktiv={zaaktiv}
                zeitarten={zeitarten}
              />
            )}
          </form>
        </Box>
      </ResponsiveDialog>
      <Grid container justifyContent="center">
        <Grid item>
          <Typography>{t("Arbeitszeiterfassung")}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid container justifyContent="center" alignItems="flex-end">
            {vg && vg !== "" && (
              <Grid item xs={12}>
                <Typography align="center" style={{ color: setColor2("255100100", 1) }}>
                  {"Stellvertretend für " + vg}
                </Typography>
              </Grid>
            )}
            {genehmigen === "1" && (
              <Grid item xs={12} sm={6} md={3}>
                <Box p={1}>
                  <TextField id="annr" label={t("Antragsteller")} fullWidth disabled value={antragsteller} variant="outlined" />
                </Box>
              </Grid>
            )}
            {genehmigen !== "1" && (
              <Grid item xs={12} sm={6} md={3}>
                <Box p={1}>
                  <TextField
                    id="zeitraum"
                    label={t("Zeitraum")}
                    select
                    fullWidth
                    value={zeitraumIndex}
                    //onChange={(e) => {setZeitraumIndex(e.target.value)}}
                    onChange={(e) => {
                      ChangeZR(e.target.value);
                      setZeitraumIndex(e.target.value);
                    }}
                    variant="outlined"
                  >
                    {zeitraum &&
                      zeitraum.map((item, index) => (
                        <MenuItem key={index} value={index}>
                          {item.bez}
                        </MenuItem>
                      ))}
                  </TextField>
                </Box>
              </Grid>
            )}
            {genehmigen === "1" && (
              <Grid item xs={12} sm={6} md={3}>
                <Box p={1}>
                  <TextField id="zeitraum" label={t("Zeitraum")} fullWidth disabled value={monattext} variant="outlined" />
                </Box>
              </Grid>
            )}
            <Grid item xs={12} sm={6} md={3}>
              <Box p={1}>
                <TextField id="aktstatus" label={t("Aktueller Status")} fullWidth disabled value={statustext} variant="outlined" />
              </Box>
            </Grid>
            {(status === "A" || status === "N") && (
              <Grid container justifyContent="center" alignItems="flex-end">
                <Grid item xs={12}>
                  <Box p={1}>
                    <TextField id="hinweisvg" label={t("Hinweis Vorgesetzter")} fullWidth disabled variant="outlined" value={hinweisvg} />
                  </Box>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid item xs={12}>
          {archiv !== "J" && (status === "O" || status === "A") && (
            <Grid container justifyContent="center">
              <Grid item xs={12} sm={6} md={3}>
                <Box p={1}>
                  <Card>
                    <Box p={1}>
                      <Grid container justifyContent="center" alignItems="center">
                        <Grid item xs={3}>
                          {paare > 1 && (
                            <IconButton
                              variant="contained"
                              color="primary"
                              onClick={() => {
                                Del();
                              }}
                            >
                              <RemoveIcon fontSize="large" />
                            </IconButton>
                          )}
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            size="small"
                            id="timepairs"
                            label={t("Anzahl Zeitpaare")}
                            fullWidth
                            variant="outlined"
                            color="primary"
                            disabled
                            value={paare.toString()}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          {paare < Math.max(stempelpaare, 3) && (
                            <IconButton
                              variant="contained"
                              color="primary"
                              onClick={() => {
                                Add();
                              }}
                            >
                              <AddIcon fontSize="large" />
                            </IconButton>
                          )}
                        </Grid>
                      </Grid>
                    </Box>
                  </Card>
                </Box>
              </Grid>
            </Grid>
          )}
        </Grid>
        <Grid item xs={12}>
          <TableContainer>
            <Table size="small">
              <TableHead>{tableHeader()}</TableHead>
              <TableBody>
                {zeilen.map((item, index) => (
                  <Child
                    key={item.key}
                    zeile={item}
                    index={index}
                    onChange={onInputChange}
                    stempelpaare={stempelpaare}
                    paare={paare}
                    status={status}
                    genehmigen={genehmigen}
                    red={item.red}
                    blue={item.blue}
                    green={item.green}
                    onClick={openPanel}
                    aufgabe="alles"
                    saldo={saldo}
                    small={small}
                    zaaktiv={zaaktiv}
                    zeitarten={zeitarten}
                  />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        {((genehmigen === "1" && saldo === "0") || saldo === "2") && (
          <Grid item xs={12}>
            <Grid container justifyContent="center">
              <Grid item lg={6} md={8} sm={10} xs={12}>
                <Box p={1}>
                  <TableContainer>
                    <Table size="small">
                      <Hidden lgDown>
                        <TableHead>
                          <TableRow>
                            <TableCell colSpan={6} align="center">
                              {t("Gleitzeit")}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                      </Hidden>
                      <Hidden lgUp>
                        <TableHead>
                          <TableRow>
                            <TableCell colSpan={2} align="center">
                              {t("Gleitzeit")}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                      </Hidden>
                      <TableBody>
                        <Hidden lgDown>
                          <TableRow>
                            <TableCell>
                              <Container>
                                <Typography component="div">Vortrag</Typography>
                              </Container>
                            </TableCell>
                            <TableCell style={{ borderRight: "1px solid " + setColor2("224224224", 1) }}>
                              <Container>
                                <Typography component="div">{vortrag}</Typography>
                              </Container>
                            </TableCell>
                            <TableCell style={{ borderLeft: "1px solid " + setColor2("224224224", 1) }}>
                              <Container>
                                <Typography component="div">Laufend</Typography>
                              </Container>
                            </TableCell>
                            <TableCell style={{ borderRight: "1px solid " + setColor2("224224224", 1) }}>
                              <Container>
                                <Typography component="div">{lfd}</Typography>
                              </Container>
                            </TableCell>
                            <TableCell style={{ borderLeft: "1px solid " + setColor2("224224224", 1) }}>
                              <Container>
                                <Typography component="div">Endstand</Typography>
                              </Container>
                            </TableCell>
                            <TableCell>
                              <Container>
                                <Typography component="div">{endstand}</Typography>
                              </Container>
                            </TableCell>
                          </TableRow>
                        </Hidden>
                        <Hidden lgUp>
                          <TableRow>
                            <TableCell>
                              <Container>
                                <Typography component="div">Vortrag</Typography>
                              </Container>
                            </TableCell>
                            <TableCell>
                              <Container>
                                <Typography component="div">{vortrag}</Typography>
                              </Container>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <Container>
                                <Typography component="div">Laufend</Typography>
                              </Container>
                            </TableCell>
                            <TableCell>
                              <Container>
                                <Typography component="div">{lfd}</Typography>
                              </Container>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <Container>
                                <Typography component="div">Endstand</Typography>
                              </Container>
                            </TableCell>
                            <TableCell>
                              <Container>
                                <Typography component="div">{endstand}</Typography>
                              </Container>
                            </TableCell>
                          </TableRow>
                        </Hidden>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        )}
        <Grid item xs={12} sx={{ padding: 2 }}>
          <Grid container justifyContent="center" alignItems="flex-end">
            <Grid item xs={12}>
              {genehmigen === "1" && (
                <Grid container justifyContent="center" alignItems="flex-end">
                  <Grid item xs={12} sm={6}>
                    <Box p={1}>
                      <TextField
                        id="vghinweis"
                        label={t("Zusätzlicher Kommentar")}
                        fullWidth
                        disabled={status === "G"}
                        value={hinweisvg}
                        onChange={(e) => {
                          setHinweisvg(e.target.value);
                        }}
                        variant="outlined"
                        style={genehmigen === "1" ? { backgroundColor: theme.palette.blocks.hyellow } : {}}
                      />
                    </Box>
                  </Grid>
                </Grid>
              )}
            </Grid>
            {genehmigen === "1" && (
              <Grid item xs={12} sm={6} md={3}>
                <Box p={1}>
                  <Button disabled={status === "G"} variant="contained" color="primary" fullWidth startIcon={<DoneIcon />} onClick={() => Aktion("genehmigen")}>
                    {t("Antrag genehmigen")}
                  </Button>
                </Box>
              </Grid>
            )}
            {genehmigen === "1" && (
              <Grid item xs={12} sm={6} md={3}>
                <Box p={1}>
                  <Button disabled={status === "G"} variant="outlined" color="primary" fullWidth startIcon={<CloseIcon />} onClick={() => Aktion("ablehnen")}>
                    {t("Antrag ablehnen")}
                  </Button>
                </Box>
              </Grid>
            )}
            {archiv !== "J" && (status === "O" || status === "A") && (
              <Grid item xs={12} sm={6} md={3}>
                <Box p={1}>
                  <Button variant="contained" color="primary" fullWidth startIcon={<RefreshIcon />} onClick={() => Aktion("aktualisieren")}>
                    {t("Speichern / Aktualisieren")}
                  </Button>
                </Box>
              </Grid>
            )}
            {archiv !== "J" && genehmigen === "0" && (status === "O" || status === "A" || status === "B" || status === "N") && (
              <Grid item xs={12} sm={6} md={3}>
                <Box p={1}>
                  <Button variant="contained" color="primary" fullWidth startIcon={<DoneIcon />} onClick={() => Aktion("aendern")}>
                    {status === "O" || status === "A" ? "Monat abschließen" : "Monat bearbeiten"}
                  </Button>
                </Box>
              </Grid>
            )}
            <Grid item xs={12} sm={6} md={3}>
              <Box p={1}>
                <Button variant="contained" color="primary" fullWidth startIcon={<InsertDriveFileOutlinedIcon />} onClick={() => openDL()}>
                  {t("Zeitjournal drucken")}
                </Button>
              </Box>
            </Grid>
            <Grid item sx={{ display: { sm: "none", xs: "block" } }} xs={12}>
              <Box p={2}></Box>
            </Grid>
            {showModal && <FullPageSpinner />}
          </Grid>
        </Grid>
      </Grid>
      <MessageBox
        open={messageBoxOpen}
        handleResponse={messageBoxResult}
        buttons="YESNO"
        text={t("Sind Sie sicher, dass Sie die Zeiten zurücksetzen möchten?")}
        title={t("Hinweis")}
        onClose={() => setMessageBoxOpen(false)}
      />
    </Fragment>
  );
}
export default Arbeitszeiterfassung;
